import {Controller} from "@hotwired/stimulus";
import {getController, getControllerAsync} from "app/app";

type Constructor<T = {}> = new (...args: any[]) => T;

export function ResolvableController<Base extends Constructor<Controller>>(Base: Base, identifier: string) {
    const derived = class extends Base
    {
        public static get<T extends Constructor<Controller>>(this: T, element: HTMLElement): InstanceType<T> | null {
            return getController(element, identifier) as InstanceType<T> | null;
        }

        public static getAsync<T extends Constructor<Controller>>(
            this: T,
            element: HTMLElement,
            timeout: number = 5000,
            poll: number = 50,
        ): Promise<InstanceType<T> | null> {
            return getControllerAsync(element, identifier, timeout, poll) as Promise<InstanceType<T> | null>;
        }
    }
    return derived;
}
